export * from './app.component';
export * from './app.module';



// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/index.ts